import { ref } from 'vue';

const disconnected = ref<boolean>(false);

export const getDisconnected = () => disconnected;

export const disconnect = () => (disconnected.value = true);
